import * as React from 'react';

const PhotoFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="photo-fill_svg__a"
                d="M0 16V0h20v16H0zm17.341-3l-3.67-4-.748.815L9.423 6 3 13H17.341zM15 7a2 2 0 100-4 2 2 0 000 4z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 4)">
            <mask id="photo-fill_svg__b" fill="#fff">
                <use xlinkHref="#photo-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#photo-fill_svg__a" />
            <g mask="url(#photo-fill_svg__b)">
                <path fill="#000" d="M-2-4h24v24H-2z" />
            </g>
        </g>
    </svg>
);

PhotoFillSvg.displayName = 'PhotoFillSvg';
export default PhotoFillSvg;
